import React from 'react';
import { useLottie } from 'lottie-react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import animationData from './background-animation.json';
import animationDataMobile from './background-animation-mobile.json';
import newAnimation from './new-animation.json';
import { useMediaMatch } from '../../../Core/hooks/useMediaMatch';
import { mdMediaMaxWidth } from '../../../cssInJs/constants';
import styles from './UpgradeBanner.scss';
// import PropTypes from 'prop-types';
// import exact from 'prop-types-exact';

const UpgradeBannerBase = () => {
  const [isMatchingMDScreen] = useMediaMatch({
    mediaMatchString: `(max-width: ${mdMediaMaxWidth}px)`,
  });

  const options = {
    animationData: isMatchingMDScreen ? animationDataMobile : newAnimation,
    loop: true,
  };

  const { View } = useLottie(options);

  return (
    <div
      className={styles.banner_container}
      onClick={async () => {
        await new MyEvent('exclusive_april_offer_click').log({
          clinicId: sessionStorage.userId,
        });
        window.open('/exclusive-april-offer.html', '_self');
      }}
    >
      <div className={styles.banner_background}>{View}</div>
      <div className={styles.data_container}>
        <div className={styles.banner_title}>
          NEW! Growth and marketing tools
        </div>
        <div className={styles.banner_description}>
          Available as an add-on to your current plan.
        </div>
        <div className={styles.banner_buttons_container}>
          <div className={styles.banner_label}>ENDS: APRIL 30TH</div>
          <div className={styles.banner_button}>
            SEE PLANS
            <KeyboardArrowRightIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

// UpgradeBannerBase.propTypes = exact({

// });

export const UpgradeBanner = React.memo(UpgradeBannerBase);
UpgradeBanner.displayName = 'UpgradeBanner';
